import { CodeListItem } from 'app/area/codetable/list/types-store';
import { RiskMatrixAxes, RiskMatrixCell, RiskMatrixDetails } from 'app/area/risk-matrix-administration/types-store';
import { ComplexValue } from 'ui';

export const ACTION = {
  SET_TYPE: 'RISK_MATRIX_ADMINISTRATION:SET_TYPE',
  SET_PREVIOUS_TYPE: 'RISK_MATRIX_ADMINISTRATION:SET_PREVIOUS_TYPE',
  SET_THIRD_AXIS_ITEM: 'RISK_MATRIX_ADMINISTRATION:SET_THIRD_AXIS_ITEM',
  SELECT_CELL: 'RISK_MATRIX_ADMINISTRATION:SELECT_CELL',
  UPDATE_MODIFIED_CELLS: 'RISK_MATRIX_ADMINISTRATION:UPDATE_MODIFIED_CELLS',
  REQUEST_DETAILS: 'RISK_MATRIX_ADMINISTRATION:REQUEST_DETAILS',
  RECEIVE_DETAILS: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_DETAILS',
  FAIL_DETAILS: 'RISK_MATRIX_ADMINISTRATION:FAIL_DETAILS',
  REQUEST_CASE_TYPES: 'RISK_MATRIX_ADMINISTRATION:REQUEST_CASE_TYPES',
  RECEIVE_CASE_TYPES: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_CASE_TYPES',
  FAIL_CASE_TYPES: 'RISK_MATRIX_ADMINISTRATION:FAIL_CASE_TYPES',
  REQUEST_CELLS: 'RISK_MATRIX_ADMINISTRATION:REQUEST_CELLS',
  RECEIVE_CELLS: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_CELLS',
  FAIL_CELLS: 'RISK_MATRIX_ADMINISTRATION:FAIL_CELLS',
  REQUEST_AXES: 'RISK_MATRIX_ADMINISTRATION:REQUEST_AXES',
  RECEIVE_AXES: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_AXES',
  FAIL_AXES: 'RISK_MATRIX_ADMINISTRATION:FAIL_AXES',
  REQUEST_RISK_AREAS: 'RISK_MATRIX_ADMINISTRATION:REQUEST_RISK_AREAS',
  RECEIVE_RISK_AREAS: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_RISK_AREAS',
  FAIL_RISK_AREAS: 'RISK_MATRIX_ADMINISTRATION:FAIL_RISK_AREAS',
  REQUEST_SAVE_CELLS: 'RISK_MATRIX_ADMINISTRATION:REQUEST_SAVE_CELLS',
  RECEIVE_SAVE_CELLS: 'RISK_MATRIX_ADMINISTRATION:RECEIVE_SAVE_CELLS',
  FAIL_SAVE_CELLS: 'RISK_MATRIX_ADMINISTRATION:FAIL_SAVE_CELLS',
  CLEAR_ALL_DATA: 'RISK_MATRIX_ADMINISTRATION:CLEAR_ALL_DATA'
};

export class SetType {
  public type: string = ACTION.SET_TYPE;
  constructor(public riskMatrixType: ComplexValue<number>) {
  }
}

export class SetPreviousType {
  public type: string = ACTION.SET_PREVIOUS_TYPE;
  constructor(public riskMatrixType: ComplexValue<number>) {
  }
}

export class SetThirdAxisItem {
  public type: string = ACTION.SET_THIRD_AXIS_ITEM;
  constructor(public thirdAxisItem: ComplexValue<number>) {
  }
}

export class SelectCell {
  public type: string = ACTION.SELECT_CELL;
  constructor(public selectedCellId: number) {
  }
}

export class UpdateModifiedCells {
  public type: string = ACTION.UPDATE_MODIFIED_CELLS;
  constructor(public modifiedCells: RiskMatrixCell[]) {
  }
}

export class RequestDetails {
  public type: string = ACTION.REQUEST_DETAILS;
}

export class ReceiveDetails {
  public type: string = ACTION.RECEIVE_DETAILS;
  constructor(public details: RiskMatrixDetails) {
  }
}

export class FailDetails {
  public type: string = ACTION.FAIL_DETAILS;
}

export class RequestCaseTypes {
  public type: string = ACTION.REQUEST_CASE_TYPES;
}

export class ReceiveCaseTypes {
  public type: string = ACTION.RECEIVE_CASE_TYPES;
  constructor(public caseTypes: ComplexValue<number>[]) {
  }
}

export class FailCaseTypes {
  public type: string = ACTION.FAIL_CASE_TYPES;
}

export class RequestCells {
  public type: string = ACTION.REQUEST_CELLS;
}

export class ReceiveCells {
  public type: string = ACTION.RECEIVE_CELLS;
  constructor(public cells: RiskMatrixCell[]) {
  }
}

export class FailCells {
  public type: string = ACTION.FAIL_CELLS;
}

export class RequestAxes {
  public type: string = ACTION.REQUEST_AXES;
}

export class ReceiveAxes {
  public type: string = ACTION.RECEIVE_AXES;
  constructor(public axes: RiskMatrixAxes) {
  }
}

export class FailAxes {
  public type: string = ACTION.FAIL_AXES;
}

export class RequestRiskAreas {
  public type: string = ACTION.REQUEST_RISK_AREAS;
}

export class ReceiveRiskAreas {
  public type: string = ACTION.RECEIVE_RISK_AREAS;
  constructor(public riskAreas: CodeListItem[]) {
  }
}

export class FailRiskAreas {
  public type: string = ACTION.FAIL_RISK_AREAS;
}

export class RequestSaveCells {
  public type: string = ACTION.REQUEST_SAVE_CELLS;
}

export class ReceiveSaveCells {
  public type: string = ACTION.RECEIVE_SAVE_CELLS;
}

export class FailSaveCells {
  public type: string = ACTION.FAIL_SAVE_CELLS;
}

export class ClearAllData {
  public type: string = ACTION.CLEAR_ALL_DATA;
}
